<template>
  <div class="main-background" :class="mainBackgroundClass">
    <div class="image-col">
      <div class="content">
        <h1>WELCOME TO THE CHANGING MINDS ONLINE MODULE</h1>
        <img class="main-image" src="https://s3-us-west-2.amazonaws.com/futures-vpv/futures-1.png" />
      </div>
    </div>
    <div class="text-col-landing">
      <div class="content">
        <p class="bold">
          Helping Children Impacted by Trauma to Heal and Thrive
        </p>
        <p>Exposure to violence in the community or at home can impact students psychologically, socially, academically, and
          behaviorally. It often results in trauma, diminished health outcomes, low academic achievement, classroom management
          issues and a hastened dispatch to child welfare or juvenile justice system--particularly for students of color.</p>
        <p>
          While the issue of children’s exposure to violence and trauma is not new for schools, there are now even more promising practices
          that can help our schools do what they do best - educate.
        </p>

        <!-- v-bind:clickevent="next_click" :customclass="[next.custom, navActive]" -->
        <div class="nav-button-wrapper" v-on:click="closeLanding">
          <nav-button type="next" customclass=" float-right call-to-action-blue">Login</nav-button>
        </div>

        <div class="links-underlay">
          <img src="https://s3-us-west-2.amazonaws.com/futures-vpv/Group.png" class="group-image" />
          <a href="http://www.discoveryeducation.com/" class="link-left" target="blank"></a>
          <a href="https://changingmindsnow.org/" class="link-right" target="blank"></a>
        </div>
      </div>
    </div>

    <div class="loading-overlay" :class="loadingOverlayClass"></div>
  </div>

</template>

<script>
  import button from '../molecules/button'
  export default {
    data () {
      return {
        mainBackgroundClass: '',
        loadingOverlayClass: ''
      }
    },
    methods: {
      closeLanding () {
        this.mainBackgroundClass = 'background-disabled'
        this.$emit('complete')
      }
    },
    mounted () {
      setTimeout(() => {
        this.loadingOverlayClass = 'overlay-disabled'
      }, 250)
    },
    components: {
      'nav-button': button
    }
  }

</script>


<style scoped lang="scss">
  @import '../../styles/variables';
  
  .main-background {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: calc(100% + 4px);
    margin-left: -2px;
    height: 100%;
    background-color: $black;
    background-image: url('https://s3-us-west-2.amazonaws.com/futures-vpv/BACKGROUND.png');
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    overflow: auto;
    overflow-x: hidden;
    @media screen and (max-width: 1100px) {
      flex-wrap: wrap;
      width: 100%;
      margin-left: 0px;
    }
    transition: all 0.8s ease-in-out;
    &.background-disabled {
      opacity: 0;
      pointer-events: none !important;
    }
  }

  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: $black;
    transition: all 0.6s ease-in-out;
    z-index: 1;
    pointer-events: none;
    &.overlay-disabled {
      opacity: 0;
    }
  }


  .image-col,
  .text-col-landing {
    position: relative;
    box-sizing: border-box;
    margin-right: calc(100% * (1/16));
    >.content {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      @media screen and (max-width: 1100px) {
        position: relative;
      }
    }
    @media screen and (max-width: 1100px) {
      width: calc(100% - 96px) !important;
      margin-left: 24px !important;
      margin-right: 0px !important;
    }
  }

  .image-col {
    width: calc(100% * (7/16));
    margin-left: calc(100% * (1/16));
    h1,
    .h1 {
      font-size: 34px;
      color: #FFFFFF;
      letter-spacing: 0;
      line-height: 48px;
    }
  }

  .text-col-landing {
    width: calc(100% * (6/16));
    margin-left: 0px;
    p,
    .p {
      color: white;
    }
  }

  .main-image {
    position: relative;
    width: 100%;
  }

  .group-image {
    position: relative;
    transform: translateX(-20px);
    @media screen and (max-width: 1100px) {
      left: 50%;
      transform: translateX(-50%) scale(0.75, 0.75);
    }
  }

  .nav-button-wrapper {
    position: relative;
    height: 48px;
    padding-top: 12px;
    padding-bottom: 12px;
    width: calc(100% - 24px);
    @media screen and (max-width: 1100px) {
      width: 100%;
    }
  }

  .links-underlay {
    position: relative;
  }

  .link-left, .link-right {
    position: absolute;
    height: 100%;
    top: 0;
    left: 0;
    background: transparent;
    width: 50%;
  }

  .link-right {
    background: transparent;
    left: initial;
    right: 0;
  }

</style>



// WEBPACK FOOTER //
// landingFirst.vue?0475ee69